import ReactQuill, { Quill } from 'react-quill';

export interface MessageContentProps {
  content: string;
  className: string;
}

export default function MessageContent(props: MessageContentProps) {
  const { content, className } = props;
  return (
    <div className={className}>
      <div
        className="ql-editor message-content"
        dangerouslySetInnerHTML={{ __html: content }}
      ></div>
    </div>
  );
}
